import { render, staticRenderFns } from "./ssoLayout.vue?vue&type=template&id=167737d2&scoped=true"
import script from "./ssoLayout.vue?vue&type=script&lang=js"
export * from "./ssoLayout.vue?vue&type=script&lang=js"
import style0 from "./ssoLayout.vue?vue&type=style&index=0&id=167737d2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167737d2",
  null
  
)

export default component.exports